<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{title ? title : 'New Pass Type'}}</h4>
                </div>
                <div class="modal-body">
                    <div class="pass-type-form">
                        <div class="row m-b-sm step-guide">
                            <div (click)="moveToTheNextStep('schedule')" class="mtv-primary-color">
                                <span>Schedule</span>
                            </div>
                            <div (click)="moveToTheNextStep('restrictions')"
                                 [ngClass]="{'mtv-primary-color' : (step == 'restrictions' || step == 'limits')}">
                                <span>Restrictions</span>
                            </div>
                            <div (click)="moveToTheNextStep('limits')" [ngClass]="{'mtv-primary-color' : (step == 'limits')}">
                                <span>Limits</span>
                            </div>
                        </div>
                        <div class="row m-b-md step-progress-bar">
                            <div class="col-sm-3" [ngStyle]="{ 'width': calculateCurrentProgressBarLength() }"></div>
                        </div>

                        <div *ngIf="step == 'schedule'">
                            <!-- ___ Name ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-6">
                                    <label>Name</label>
                                </div>
                                <div class="col-md-6 fourteenPixelText">
                                    <input class="form-control" name="name" [(ngModel)]="data.name" required>
                                </div>
                            </div>

                            <!-- ___ Repeat ___ -->
                            <div class="settings-amenities-slider-container pass-type-slider-container"
                                 *ngIf="settingsParkingPassesService.selectedItemData.type == 'general'">
                                <span>Repeat</span>
                                <mat-slide-toggle name="repeatable" [(ngModel)]="data.passTypeSchedule.repeatable">
                                </mat-slide-toggle>
                            </div>

                            <!--&lt;!&ndash; ___ Repeat Every ___ &ndash;&gt;-->
                            <!--<div class="row m-b-sm" *ngIf="data.passTypeSchedule.repeatable">-->
                                <!--<div class="col-md-6">-->
                                    <!--<label>Repeat Every</label>-->
                                <!--</div>-->
                                <!--<div class="col-md-6 restrictions-input-select">-->
                                    <!--<input class="form-control phoneInput"-->
                                           <!--[(ngModel)]="data.passTypeSchedule.repeatEvery.number"-->
                                           <!--name="repeatEvery"-->
                                           <!--maxlength="255"-->
                                           <!--pattern="[0-9]+">-->

                                    <!--<select [(ngModel)]="data.passTypeSchedule.repeatEvery.selectValue"-->
                                            <!--class="form-control" name="select">-->
                                        <!--<option value="" hidden></option>-->
                                        <!--<option *ngFor="let type of selectValues" [value]="type.name">-->
                                            <!--{{type.displayName}}-->
                                        <!--</option>-->
                                    <!--</select>-->
                                <!--</div>-->
                            <!--</div>-->

                            <div class="row m-b-sm"
                                 *ngIf="settingsParkingPassesService.selectedItemData.type == 'general' && data.passTypeSchedule.repeatable">
                                <div *ngFor="let day of selectedRepeatableDays; let index = index; let first = first;">
                                    <div class="col-md-6">
                                        <label *ngIf="first">Repeat On</label>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="img-checkbox">
                                            <input id="repeatOnDay{{index}}"
                                                   type="checkbox"
                                                   name="repeatOnDay{{index}}"
                                                   [(ngModel)]="selectedRepeatableDays[index].selected">
                                            <label for="repeatOnDay{{index}}"><svg-checked></svg-checked></label>
                                            <span>{{weekDaysNamesArray[index]}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <!-- ___ Start On  ___ -->
                            <div class="row m-b-sm start-end-on"
                                 *ngIf="settingsParkingPassesService.selectedItemData.type == 'general'">
                                <div class="col-md-3">
                                    <label>Start On</label>
                                </div>
                                <div class="col-md-9">
                                    <select class="form-control" name="startDayNumber"
                                            *ngIf="!data.passTypeSchedule.repeatable"
                                            [(ngModel)]="data.passTypeSchedule.startDayNumber" required>
                                        <option value="" hidden></option>
                                        <option *ngFor="let day of weekDaysNamesArray; let index = index"
                                                [value]="index+1">
                                            {{day}}
                                        </option>
                                    </select>
                                    <div class="max-time-select-width">
                                        <select class="form-control"
                                                name="startOnHours"
                                                [(ngModel)]="startOnTime.hours"
                                                required
                                                (change)="startOnTime.minutes = startOnTime.minutes ? startOnTime.minutes : '00'">
                                            <option value="" hidden></option>
                                            <option *ngFor="let hour of hoursArray" [value]="hour">{{hour}}</option>
                                        </select>
                                        <select class="form-control"
                                                name="startOnMinutes"
                                                [(ngModel)]="startOnTime.minutes"
                                                required>
                                            <option value="" hidden></option>
                                            <option *ngFor="let minutes of minutesArray" [value]="minutes">
                                                {{minutes}}
                                            </option>
                                        </select>
                                        <select class="form-control"
                                                name="startOnAmPm"
                                                [(ngModel)]="startOnTime.amPM" required>
                                            <option value="" hidden></option>
                                            <option [value]="'AM'">AM</option>
                                            <option [value]="'PM'">PM</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <!-- ___ End On  ___ -->
                            <div class="row m-b-sm start-end-on"
                                 *ngIf="settingsParkingPassesService.selectedItemData.type == 'general'">
                                <div class="col-md-3">
                                    <label>End On</label>
                                </div>
                                <div class="col-md-9">
                                    <select class="form-control"
                                            name="endDayNumber"
                                            *ngIf="!data.passTypeSchedule.repeatable"
                                            [disabled]="!data.passTypeSchedule.startDayNumber"
                                            [(ngModel)]="data.passTypeSchedule.endDayNumber" required>
                                        <option value="" hidden></option>
                                        <option *ngFor="let day of weekDaysNamesArray; let index = index"
                                                [value]="index+1">
                                            {{day}}
                                        </option>
                                    </select>
                                    <div class="max-time-select-width">
                                        <select class="form-control"
                                                name="endOnHours"
                                                [(ngModel)]="endOnTime.hours"
                                                required
                                                (change)="endOnTime.minutes = endOnTime.minutes ? endOnTime.minutes : '00'">
                                            <option value="" hidden></option>
                                            <option *ngFor="let hour of hoursArray" [value]="hour">{{hour}}</option>
                                        </select>
                                        <select class="form-control"
                                                name="endOnMinutes"
                                                [(ngModel)]="endOnTime.minutes" required>
                                            <option value="" hidden></option>
                                            <option *ngFor="let minutes of minutesArray" [value]="minutes">
                                                {{minutes}}
                                            </option>
                                        </select>
                                        <select class="form-control" name="endOnAmPm" [(ngModel)]="endOnTime.amPM" required>
                                            <option value="" hidden></option>
                                            <option [value]="'AM'">AM</option>
                                            <option [value]="'PM'">PM</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <!-- ___ End On  ___ -->
                            <div class="row m-b-sm start-end-on"
                                 *ngIf="settingsParkingPassesService.selectedItemData.type == 'sliding'">
                                <div class="col-md-6">
                                    <label>One Pass Duration</label>
                                </div>
                                <div class="col-md-6">
                                    <input class="form-control"
                                           style="width: 120px;"
                                           name="slidingPeriodCount"
                                           [(ngModel)]="data.passTypeScheduleSliding.slidingPeriodCount" required>
                                    <select class="form-control"
                                            style="height: 25px;"
                                            name="slidingSequenceType"
                                            [(ngModel)]="data.passTypeScheduleSliding.slidingSequenceType" required>
                                        <option value="" hidden></option>
                                        <option value="hour">Hour</option>
                                        <option value="day">Day</option>
                                        <option value="week">Week</option>
                                        <option value="month">Month</option>
                                        <option value="year">Year</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row text-center space-30">
                                <button class="btn btn-primary submit-btn"
                                        type="submit"
                                        (click)="moveToTheNextStep('restrictions')">
                                    Continue
                                </button>
                            </div>
                        </div>
                        <div *ngIf="step == 'restrictions'">
                            <!-- ___ Pass Limit ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-6">
                                    <label>Pass Limit</label>
                                </div>
                                <div class="col-md-6 restrictions-input-select">
                                    <input class="form-control phoneInput"
                                           [(ngModel)]="data.maxTotalPassTypeCount"
                                           name="passLimitCount"
                                           maxlength="255"
                                           type="text"
                                           pattern="[0-9]+"
                                           (keypress)="validateValue($event)">

                                    <select [(ngModel)]="data.maxTotalPassTypeSequenceType"
                                            class="form-control"
                                            name="passLimitSequenceType">
                                        <option value="" hidden></option>
                                        <option *ngFor="let type of selectPerValues" [value]="type.name">
                                            {{type.displayName}}
                                        </option>
                                    </select>
                                    <button type="button"
                                            (click)="clearSpecialField('maxTotalPassTypeCount', 'maxTotalPassTypeSequenceType')">
                                        <i class="fa fa-trash without-hover"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- ___ Max Time For Advanced Booking ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-6">
                                    <label>Max Time For Advanced Booking</label>
                                </div>
                                <div class="col-md-6 restrictions-input-select">
                                    <input class="form-control phoneInput"
                                           [(ngModel)]="data.maxTimeForAdvancedBookingCount"
                                           name="maxTimeForAdvancedBookingCount"
                                           maxlength="255"
                                           type="text"
                                           pattern="[0-9]+"
                                           (keypress)="validateValue($event)">

                                    <select [(ngModel)]="data.maxTimeForAdvancedBookingSequenceType"
                                            class="form-control"
                                            name="maxTimeForAdvancedBookingSequenceType">
                                        <option value="" hidden></option>
                                        <option *ngFor="let type of selectValues" [value]="type.name">
                                            {{type.displayName}}
                                        </option>
                                    </select>
                                    <button type="button"
                                            (click)="clearSpecialField('maxTimeForAdvancedBookingCount', 'maxTimeForAdvancedBookingSequenceType')">
                                        <i class="fa fa-trash without-hover"></i>
                                    </button>
                                </div>
                            </div>

                            <!--<div class="row m-b-sm">-->
                                <!--<div class="col-md-6">-->
                                    <!--<label>Max # of Days Allowed Per Booking</label>-->
                                <!--</div>-->
                                <!--<div class="col-md-6 fourteenPixelText">-->
                                    <!--<input class="amenity-tiles-content"-->
                                           <!--name="bookingMaxDay"-->
                                           <!--[(ngModel)]="data.maxOfDaysPerBooking"-->
                                           <!--type="text"-->
                                           <!--pattern="[0-9]+"-->
                                           <!--(keypress)="validateValue($event)">-->
                                <!--</div>-->
                            <!--</div>-->

                            <div class="settings-amenities-slider-container pass-type-slider-container">
                                <span>Requires Staff Approval</span>
                                <mat-slide-toggle name="status" [(ngModel)]="data.requiresManagerApproval">
                                </mat-slide-toggle>
                            </div>

                            <div class="row text-center space-30">
                                <button class="btn btn-primary submit-btn"
                                        type="submit"
                                        (click)="moveToTheNextStep('limits')">
                                    Continue
                                </button>
                            </div>
                        </div>
                        <div *ngIf="step == 'limits'">
                            <!-- ___ Max Per Unit ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-6">
                                    <label>Max Per Unit</label>
                                </div>
                                <div class="col-md-6 restrictions-input-select">
                                    <input class="form-control phoneInput"
                                           [(ngModel)]="data.maxPerSuiteCount"
                                           name="maxPerSuiteCount"
                                           maxlength="255"
                                           type="text"
                                           pattern="[0-9]+"
                                           (keypress)="validateValue($event)">

                                    <select [(ngModel)]="data.maxPerSuiteSequenceType"
                                            class="form-control"
                                            name="maxPerSuiteSequenceType">
                                        <option value="" hidden></option>
                                        <option *ngFor="let type of selectPerValues" [value]="type.name">
                                            {{type.displayName}}
                                        </option>
                                    </select>
                                    <button type="button"
                                            (click)="clearSpecialField('maxPerSuiteCount', 'maxPerSuiteSequenceType')">
                                        <i class="fa fa-trash without-hover"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- ___ Max Per License Plate ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-6">
                                    <label>Max Per License Plate</label>
                                </div>
                                <div class="col-md-6 restrictions-input-select">
                                    <input class="form-control phoneInput"
                                           [(ngModel)]="data.maxPerLicensePlateCount"
                                           name="maxPerLicensePlateCount"
                                           maxlength="255"
                                           type="text"
                                           pattern="[0-9]+"
                                           (keypress)="validateValue($event)">

                                    <select [(ngModel)]="data.maxPerLicensePlateSequenceType"
                                            class="form-control"
                                            name="maxPerLicensePlateSequenceType">
                                        <option value="" hidden></option>
                                        <option *ngFor="let type of selectPerValues" [value]="type.name">
                                            {{type.displayName}}
                                        </option>
                                    </select>
                                    <button type="button"
                                            (click)="clearSpecialField('maxPerLicensePlateCount', 'maxPerLicensePlateSequenceType')">
                                        <i class="fa fa-trash without-hover"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="settings-amenities-slider-container pass-type-slider-container">
                                <span>Allow Overlimit Bookings</span>
                                <mat-slide-toggle name="allowOverlimitBooking" [(ngModel)]="data.allowOverlimitBooking">
                                </mat-slide-toggle>
                            </div>

                            <!--<div class="settings-amenities-slider-container pass-type-slider-container">-->
                                <!--<span class="display-inline">-->
                                    <!--<span style="margin-top: 2px;">Fee</span>-->
                                    <!--<span class="fee-input-dollar">$</span>-->
                                    <!--<input class="form-control m-l-sm"-->
                                           <!--[(ngModel)]="data.fee"-->
                                           <!--name="fee"-->
                                           <!--maxlength="255"-->
                                           <!--type="text"-->
                                           <!--pattern="[0-9\.,]+"-->
                                           <!--(keypress)="validateFeeValue($event)"-->
                                           <!--[disabled]="!data.feeEnabledStatus">-->
                                <!--</span>-->
                                <!--<mat-slide-toggle name="feeEnabledStatus" [(ngModel)]="data.feeEnabledStatus"></mat-slide-toggle>-->
                            <!--</div>-->

                            <div class="settings-amenities-slider-container pass-type-slider-container">
                                <span>Print Unit # on Parking Pass</span>
                                <mat-slide-toggle name="printSuiteOnParkingPass"
                                                  [(ngModel)]="data.printSuiteOnParkingPass">
                                </mat-slide-toggle>
                            </div>

                            <div class="settings-amenities-slider-container pass-type-slider-container">
                                <span>Do Not Allow Resident Plates</span>
                                <mat-slide-toggle name="doNotAllowResidentsPlates"
                                                  [(ngModel)]="data.doNotAllowResidentsPlates">
                                </mat-slide-toggle>
                            </div>

                            <div class="settings-amenities-slider-container pass-type-slider-container">
                                <span>Allow Self Printing By Residents</span>
                                <mat-slide-toggle name="allowSelfPrintingByResidents"
                                                  [(ngModel)]="data.allowSelfPrintingByResidents">
                                </mat-slide-toggle>
                            </div>

                            <div class="row text-center space-30">
                                <button class="btn btn-primary submit-btn"
                                        type="submit"
                                        [disabled]="disabledSubmit"
                                        (click)="submitPassType(form)">
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-scheduler" *ngIf="showSchedulerSpinner">
                        <div id="modalScheduler"></div>
                        <spinner [spinnerShow]="showSchedulerSpinner"></spinner>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/pass-type-modal/pass-type-modal.component.html